import React from 'react';
import {Content, Text} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const WhistleContent = styled(Content)`
  justify-content: center;
  align-items: center;
  background: ${COLORS.lightestGrey};
  padding: 1rem 0;
  gap: 0.25rem;
`;

const MatchEventWhistle = ({event}) => {
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  return (
    <WhistleContent>
      <Text variant='subheading2' component={'span'}>
        {event.text}
      </Text>
      <Typography variant={'body2'} component='span'>
        {time}
      </Typography>
    </WhistleContent>
  );
};

export default MatchEventWhistle;
